import React, { useEffect, useContext } from "react";
import { observer } from "mobx-react-lite";
import GiveRate from "./rate/GiveRate";
import { RateStoreContext } from "../stores/RateStore";
import ModalCalculatingRate from "./rate/ModalCalculatingRate";
import ModalTooHigh from "./rate/ModalTooHigh";
import { Loader } from "semantic-ui-react";
import { AppStoreContext } from "../stores/AppStore";
import { runInAction } from "mobx";
import ModalDone from "./rate/ModalDone";
import ModalNegotiateNeeded from "./rate/ModalNegotiateNeeded";
import { GLOBAL_MODALS } from "../stores/modals";
export default observer(function Rate() {
  const appStore = useContext(AppStoreContext);
  const { globalModal } = appStore;
  const rateStore = useContext(RateStoreContext);
  const {
    recommendationLoadingStatus,
    recommendationLoadingPercent,
    approvalNeeded,
    negotiateNeeded,
    isLoading,
    isDone
  } = rateStore;

  useEffect(() => {
    if (rateStore.rateAmountOriginal > 0) {
      rateStore.isDone = true;
      appStore.globalModal = GLOBAL_MODALS.WHATS_NEXT;
    } else if (!rateStore.rateStatus) {
      rateStore.getNegotiated().catch(() =>
        runInAction(() => (appStore.globalModal = GLOBAL_MODALS.FATAL_ERROR))
      );
    }
  }, [rateStore, appStore]);

  if (globalModal !== GLOBAL_MODALS.NONE) {
    return null;
  }

  return (
    <div className="view view-container">
      {isLoading && <Loader active inline />}
      {isLoading === false && <GiveRate />}

      {recommendationLoadingStatus === "loading" && (
        <ModalCalculatingRate percent={recommendationLoadingPercent} />
      )}
      {!isDone && approvalNeeded && <ModalTooHigh />}
      {!isDone && negotiateNeeded && <ModalNegotiateNeeded />}
      {isDone && <ModalDone />}
    </div>
  );
});
